import React, { useEffect, useState } from "react";
import { useTranslation } from "../../i18n/TranslationContext";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import "./ContactUs.css";

function MailIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3 6.75A1.75 1.75 0 0 1 4.75 5h14.5A1.75 1.75 0 0 1 21 6.75v10.5A1.75 1.75 0 0 1 19.25 19H4.75A1.75 1.75 0 0 1 3 17.25V6.75zm1.8.1 7.2 5.2 7.2-5.2a.5.5 0 0 0-.45-.1H5.25a.5.5 0 0 0-.45.1zm14.7 1.55-7.06 5.1a.75.75 0 0 1-.88 0L4.5 8.4v8.85c0 .14.11.25.25.25h14.5c.14 0 .25-.11.25-.25V8.4z" />
    </svg>
  );
}

function PhoneIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M6.62 3.5h2.13c.39 0 .73.27.82.65l.74 3.11a.88.88 0 0 1-.25.85L8.5 9.64a13.2 13.2 0 0 0 5.86 5.86l1.53-1.56a.88.88 0 0 1 .85-.25l3.11.74c.38.09.65.43.65.82v2.13c0 .49-.4.89-.89.89C10.16 19 5 13.84 5 7.39c0-.49.4-.89.89-.89h.73z" />
    </svg>
  );
}

export default function ContactUs() {
  const { t, lang, toggleLang } = useTranslation();

  const [theme, setTheme] = useState(
    () => localStorage.getItem("theme") || "dark",
  );

  useEffect(() => {
    localStorage.setItem("theme", theme);
    document.body.classList.remove("theme-light", "theme-dark");
    document.body.classList.add(`theme-${theme}`);
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <div
      className={`aq-home aq-contact-page theme-${theme}`}
      dir={lang === "ar" ? "rtl" : "ltr"}
      lang={lang}
    >
      <Header
        theme={theme}
        lang={lang}
        t={t}
        onToggleTheme={toggleTheme}
        onToggleLang={toggleLang}
        onDownload={() => {}}
        onScroll={() => {}}
      />

      <main className="aq-contact-section">
        <div className="aq-container">
          <div className="aq-contact-shell">
            <div className="aq-contact-head">
              <span className="aq-contact-kicker">Aman-QO</span>

              <h1 className="aq-contact-title">
                {lang === "ar" ? "تواصل معنا" : "Contact Us"}
              </h1>

              <p className="aq-contact-desc aq-muted">
                {lang === "ar"
                  ? "يسعدنا تواصلكم معنا لأي استفسارات أو شراكات أو دعم. يمكنكم التواصل معنا مباشرة عبر البريد الإلكتروني أو رقم الهاتف التالي."
                  : "We would be happy to hear from you for any inquiries, partnerships, or support. You can reach us directly using the email or phone number below."}
              </p>
            </div>

            <div className="aq-contact-grid">
              <div className="aq-card aq-card-glow aq-contact-card">
                <div className="aq-contact-card-top">
                  <div className="aq-contact-icon" aria-hidden="true">
                    <MailIcon />
                  </div>

                  <div className="aq-contact-meta">
                    <div className="aq-contact-label">
                      {lang === "ar" ? "البريد الإلكتروني" : "Email"}
                    </div>

                    <a
                      href="mailto:amanqo.hq@gmail.com"
                      className="aq-contact-value"
                    >
                      amanqo.hq@gmail.com
                    </a>
                  </div>
                </div>

                <p className="aq-contact-note aq-muted">
                  {lang === "ar"
                    ? "راسلنا مباشرة وسنقوم بالرد عليكم في أقرب وقت."
                    : "Email us directly and we will get back to you as soon as possible."}
                </p>
              </div>

              <div className="aq-card aq-card-glow aq-contact-card">
                <div className="aq-contact-card-top">
                  <div className="aq-contact-icon" aria-hidden="true">
                    <PhoneIcon />
                  </div>

                  <div className="aq-contact-meta">
                    <div className="aq-contact-label">
                      {lang === "ar" ? "رقم الهاتف" : "Phone"}
                    </div>

                    <a href="tel:+201130479570" className="aq-contact-value">
                      +201130479570
                    </a>
                  </div>
                </div>

                <p className="aq-contact-note aq-muted">
                  {lang === "ar"
                    ? "يمكنكم التواصل معنا عبر الهاتف للاستفسارات والدعم."
                    : "You can call us directly for inquiries and support."}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer lang={lang} t={t} />
    </div>
  );
}